export default {
  mainContainer: 'bg-color-bg w-[100%] pb-[15vh] h-[100vh]',
  container: 'max-w-[1440px] mx-auto',
  contentContainer: 'flex items-center justify-center sm:pt-[120px] pt-[200px] p-4',
  contentWrapper: 'w-full max-w-[450px] px-[32px] py-[42px] rounded-3xl bg-color-white',
  title: 'font-interSemibold sm:text-[32px] text-[24px] text-[#101828] text-center mb-4',
  inputsWrapper: 'flex flex-col gap-[24px] mt-6',
  text: 'mb-6 mt-1 text-right text-color-blue font-interSemibold text-base',
};
